export default function Head({ step }) {
  return (
    <div className="flex flex-col py-4 2xl:pt-12">
      <div className="flex flex-row items-center justify-center w-full">
        <span
          className={`
            ${step > 1 && 'bg-primary text-white border-primary'}
            ${step === 1 ? 'border-primary text-primary' : 'text-blackFont-600 dark:text-blackFont-400'}
            w-5 h-5 lg:h-6 lg:w-6 border-[2px] rounded-full flex items-center justify-center text-base font-medium transition-all`}
        >
          {step > 1 ? <span className="w-2 h-2 rounded-full bg-white transition-all"></span> : ''}
        </span>
        <span
          className={`${step > 1 ? 'bg-primary' : 'bg-blackFont-200 dark:bg-blackFont-700'} w-24 lg:w-40 h-[2px] transition-all`}
        ></span>
        <span
          className={`
            ${step > 2 && 'bg-primary text-white border-primary'}
            ${step === 2 ? 'border-primary text-primary' : 'text-blackFont-600 dark:text-blackFont-400'}
            w-5 h-5 lg:h-6 lg:w-6 border-[2px] rounded-full flex items-center justify-center text-base font-medium transition-all`}
        >
          {step > 2 ? <span className="w-2 h-2 rounded-full bg-white transition-all"></span> : ''}
        </span>
        <span
          className={`${step > 2 ? 'bg-primary' : 'bg-blackFont-200 dark:bg-blackFont-700'} w-24 lg:w-40 h-[2px] transition-all`}
        ></span>
        <span
          className={`
            ${step > 3 && 'bg-primary text-white border-primary'}
            ${step === 3 ? 'border-primary text-primary' : 'text-blackFont-600 dark:text-blackFont-400'}
            w-5 h-5 lg:h-6 lg:w-6 border-[2px] rounded-full flex items-center justify-center text-base font-medium transition-all`}
        >
          {step > 3 ? <span className="w-2 h-2 rounded-full bg-white transition-all"></span> : ''}
        </span>
      </div>
      <div className="flex flex-row items-center justify-center whitespace-nowrap w-full">
        <span
          className={`
          ${step >= 1 ? 'text-primary' : 'text-blackFont-600 dark:text-blackFont-400'}
          w-5 h-5 lg:h-6 lg:w-6 mt-2 lg:mt-4 rounded-full flex items-center text-xs lg:text-base justify-center font-medium text-center`}
        >
          مشخصات مدیر
        </span>
        <span className="w-24 lg:w-40 h-[2px] transition-all"></span>
        <span
          className={`
          ${step >= 2 ? 'text-primary' : 'text-blackFont-600 dark:text-blackFont-400'}
          w-5 h-5 lg:h-6 lg:w-6 mt-2 lg:mt-4 rounded-full flex items-center text-xs lg:text-base justify-center font-medium text-center`}
        >
          مشخصات آژانس
        </span>
        <span className="w-24 lg:w-40 h-[2px] transition-all"></span>
        <span
          className={`
          ${step >= 3 ? 'text-primary' : 'text-blackFont-600 dark:text-blackFont-400'}
          w-5 h-5 lg:h-6 lg:w-6 mt-2 lg:mt-4 rounded-full flex items-center text-xs lg:text-base justify-center font-medium text-center`}
        >
          آدرس
        </span>
      </div>
    </div>
  );
}
